/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdditionalServicePageItemRespVo } from './AdditionalServicePageItemRespVo';
import {
    AdditionalServicePageItemRespVoFromJSON,
    AdditionalServicePageItemRespVoFromJSONTyped,
    AdditionalServicePageItemRespVoToJSON,
    AdditionalServicePageItemRespVoToJSONTyped,
} from './AdditionalServicePageItemRespVo';

/**
 * 
 * @export
 * @interface PageDataAdditionalServicePageItemRespVo
 */
export interface PageDataAdditionalServicePageItemRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataAdditionalServicePageItemRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataAdditionalServicePageItemRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataAdditionalServicePageItemRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<AdditionalServicePageItemRespVo>}
     * @memberof PageDataAdditionalServicePageItemRespVo
     */
    records?: Array<AdditionalServicePageItemRespVo>;
}

/**
 * Check if a given object implements the PageDataAdditionalServicePageItemRespVo interface.
 */
export function instanceOfPageDataAdditionalServicePageItemRespVo(value: object): value is PageDataAdditionalServicePageItemRespVo {
    return true;
}

export function PageDataAdditionalServicePageItemRespVoFromJSON(json: any): PageDataAdditionalServicePageItemRespVo {
    return PageDataAdditionalServicePageItemRespVoFromJSONTyped(json, false);
}

export function PageDataAdditionalServicePageItemRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataAdditionalServicePageItemRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(AdditionalServicePageItemRespVoFromJSON)),
    };
}

export function PageDataAdditionalServicePageItemRespVoToJSON(json: any): PageDataAdditionalServicePageItemRespVo {
    return PageDataAdditionalServicePageItemRespVoToJSONTyped(json, false);
}

export function PageDataAdditionalServicePageItemRespVoToJSONTyped(value?: PageDataAdditionalServicePageItemRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(AdditionalServicePageItemRespVoToJSON)),
    };
}

